import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {Socket} from "ngx-socket-io";
import {environment} from "@shared-environments/environment";
import {StorageService} from "../storage.service";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class SocketConnect extends Socket {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    super( { url: environment.socketUrl,
        options: {
            query: {
              token: environment.authHeaderPrefix + StorageService.getToken() + environment.authHeaderSufix
            },
            autoConnect: isPlatformBrowser(platformId),
            reconnection: isPlatformBrowser(platformId),                // Enable reconnection
            reconnectionAttempts: Infinity,    // Retry indefinitely
            reconnectionDelay: 1000,           // Initial delay of 1 second
            reconnectionDelayMax: 3000         // Max delay of 5 seconds between attempts
        } });
  }


  //@ts-ignore
  disconnect(_close?: any): any {
    return super.disconnect(_close);
  }

  //@ts-ignore
  connect(): any {
    return  super.connect();
  }

  public checkConnection(){
    return super.connect();
  }
}
